import {
  SHOW_SHORTENED_FORM,
  SHOW_FULL_FORM,
} from 'marketing-website/constants/actions';

export function showShortenedForm({ email }) {
  return {
    type: SHOW_SHORTENED_FORM,
    email,
  };
}

export function showFullForm() {
  return {
    type: SHOW_FULL_FORM,
  };
}



// WEBPACK FOOTER //
// ./src/actionCreators/signup.js